import { Autocomplete, createFilterOptions, TextField } from '@mui/material'
import { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type Opcao = string | { inputValue: string; label: string }

const filtro = createFilterOptions<Opcao>()

/** Segmentos mais comuns entre clientes do Ponto Ágil. Não precisa bater 1:1
 * com a tabela: o usuário pode digitar qualquer outro (freeSolo) e o backend
 * resolve por nome (cria se não existir) no cadastro da avaliação. */
const PRINCIPAIS_SEGMENTOS = [
    'Indústria',
    'Construtora',
    'Restaurante',
    'Supermercado',
    'Escritório de contabilidade',
    'Clínica médica',
    'Escola',
    'Transportadora',
    'Hotel',
    'Loja de roupas',
    'Farmácia',
    'Oficinas',
]

interface IProps {
    required?: boolean
}

export function SelectSegmento({ required }: IProps) {
    const { control } = useFormContext()
    const [inputValue, setInputValue] = useState('')

    return (
        <Controller
            name="Segmento.nome"
            control={control}
            rules={required ? { required: 'Obrigatório' } : undefined}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Autocomplete
                    freeSolo
                    options={PRINCIPAIS_SEGMENTOS}
                    value={value || null}
                    inputValue={inputValue}
                    onInputChange={(_, novoValor) => setInputValue(novoValor)}
                    onChange={(_, novoValor) => {
                        const nome = !novoValor
                            ? ''
                            : typeof novoValor === 'string'
                              ? novoValor
                              : novoValor.inputValue
                        onChange(nome)
                    }}
                    onBlur={() => onChange(inputValue)}
                    filterOptions={(options, params) => {
                        const filtered = filtro(options, params)
                        const jaExiste = options.some(
                            opcao =>
                                opcao.toLowerCase() ===
                                params.inputValue.toLowerCase(),
                        )
                        if (params.inputValue !== '' && !jaExiste) {
                            filtered.push({
                                inputValue: params.inputValue,
                                label: `Outro: ${params.inputValue}`,
                            })
                        }
                        return filtered
                    }}
                    getOptionLabel={opcao =>
                        typeof opcao === 'string' ? opcao : opcao.label
                    }
                    isOptionEqualToValue={(opcao, valorAtual) =>
                        (typeof opcao === 'string' ? opcao : opcao.label) ===
                        valorAtual
                    }
                    renderInput={props => (
                        <TextField
                            {...props}
                            variant="filled"
                            label="Segmento"
                            placeholder="Digite ou escolha o segmento"
                            required={required}
                            error={!!error}
                            helperText={error?.message}
                        />
                    )}
                />
            )}
        />
    )
}
